export default __webpack_public_path__ + "static/thumb-8-10e60ce4b6ee8a9bf28361828edc2a38.jpg";